import { useState } from "react";
import { EnemyIntel } from "../components/EnemyIntel";
import { GameCanvas } from "../components/GameCanvas";
import { Hud } from "../components/Hud";
import { RewardPanel } from "../components/RewardPanel";
import { TowerDock } from "../components/TowerDock";

const mobilePanels = [
	{ id: "towers", label: "Towers", icon: "TWR" },
	{ id: "rewards", label: "Rewards", icon: "ADS" },
];

export function GameScreen({ controller }) {
	const [mobilePanel, setMobilePanel] = useState(null);
	const [hostilesOpen, setHostilesOpen] = useState(false);

	return (
		<main className="game-screen">
			<Hud
				ui={controller.ui}
				currentMap={controller.currentMap}
				limits={controller.limits}
				actions={controller.actions}
				busy={controller.busy}
				onOpenHostiles={() => setHostilesOpen(true)}
			/>
			<div className="game-layout">
				<div className="game-layout__board">
					<GameCanvas controller={controller} />
				</div>
				<aside className="side-rail desktop-rail">
					<div className="desktop-dock">
						<TowerDock ui={controller.ui} currentMap={controller.currentMap} actions={controller.actions} selectedDef={controller.selectedDef} limits={controller.limits} />
					</div>
					<RewardPanel controller={controller} />
				</aside>
				<section className={`mobile-command-panel ${mobilePanel ? "is-open" : ""}`}>
					<nav className="mobile-command-tabs" aria-label="Mobile command panels">
						{mobilePanels.map((panel) => (
							<button
								key={panel.id}
								type="button"
								className={mobilePanel === panel.id ? "is-active" : ""}
								onClick={() => setMobilePanel((current) => current === panel.id ? null : panel.id)}
							>
								<span>{panel.icon}</span>
								{panel.label}
							</button>
						))}
					</nav>
					{mobilePanel && (
						<div className="mobile-command-body">
							{mobilePanel === "towers" && <TowerDock ui={controller.ui} currentMap={controller.currentMap} actions={controller.actions} selectedDef={controller.selectedDef} limits={controller.limits} />}
							{mobilePanel === "rewards" && <RewardPanel controller={controller} />}
						</div>
					)}
				</section>
			</div>
			{hostilesOpen && (
				<div className="hostiles-overlay" role="dialog" aria-modal="true" aria-label="Hostile roster">
					<button type="button" className="hostiles-overlay__scrim" aria-label="Close hostile roster" onClick={() => setHostilesOpen(false)} />
					<div className="hostiles-overlay__panel">
						<EnemyIntel mapIdx={controller.ui.mapIdx} mapDef={controller.currentMap} onClose={() => setHostilesOpen(false)} />
					</div>
				</div>
			)}
		</main>
	);
}
